export default [
    {
        comment: '',
        error_id: 'T-FLW-01',
        base_profile_names: ['Profile1', 'Profile2'],
        cmp_profile_names: ['Profile1', 'Profile2', 'Profile3'],
        data: [
            {
                "cross_section": "60380",
                "sel_profile_data": [
                    {
                        "value": 1240
                    },
                    {
                        "value": 1240
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 1240,
                        "cmp_index": 1
                    },
                    {
                        "value": 1240,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "59553",
                "sel_profile_data": [
                    {
                        "value": 1270
                    },
                    {
                        "value": 1270
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 1270,
                        "cmp_index": 1
                    },
                    {
                        "value": 5412,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "58594",
                "sel_profile_data": [
                    {
                        "value": 1640
                    },
                    {
                        "value": 1640
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 1640,
                        "cmp_index": 1
                    },
                    {
                        "value": 1640,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "57252",
                "sel_profile_data": [
                    {
                        "value": 1830
                    },
                    {
                        "value": 1830
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 3640,
                        "cmp_index": 1
                    },
                    {
                        "value": 1830,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "56831",
                "sel_profile_data": [
                    {
                        "value": 1930
                    },
                    {
                        "value": 1930
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 1930,
                        "cmp_index": 1
                    },
                    {
                        "value": 1930,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "54650",
                "sel_profile_data": [
                    {
                        "value": 2670
                    },
                    {
                        "value": 2670
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 2670,
                        "cmp_index": 1
                    },
                    {
                        "value": 2670,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "54334",
                "sel_profile_data": [
                    {
                        "value": 2720
                    },
                    {
                        "value": 2720
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 2780,
                        "cmp_index": 1
                    },
                    {
                        "value": 2720,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "52695",
                "sel_profile_data": [
                    {
                        "value": 2800
                    },
                    {
                        "value": 2800
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 2800,
                        "cmp_index": 1
                    },
                    {
                        "value": 2800,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "51368",
                "sel_profile_data": [
                    {
                        "value": 3060
                    },
                    {
                        "value": 3060
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 3060,
                        "cmp_index": 1
                    },
                    {
                        "value": 3060,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "47373",
                "sel_profile_data": [
                    {
                        "value": 3140
                    },
                    {
                        "value": 3140
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 3140,
                        "cmp_index": 1
                    },
                    {
                        "value": 3140,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "46981",
                "sel_profile_data": [
                    {
                        "value": 3180
                    },
                    {
                        "value": 3180
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 3180,
                        "cmp_index": 1
                    },
                    {
                        "value": 3180,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "44984",
                "sel_profile_data": [
                    {
                        "value": 4090
                    },
                    {
                        "value": 4090
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 4090,
                        "cmp_index": 1
                    },
                    {
                        "value": 4090,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            },
            {
                "cross_section": "44672",
                "sel_profile_data": [
                    {
                        "value": 4150
                    },
                    {
                        "value": 4150
                    }
                ],
                "cmp_profile_data": [
                    {
                        "value": 4150,
                        "cmp_index": 1
                    },
                    {
                        "value": 4150,
                        "cmp_index": 0
                    },
                    {
                        "value": 1240,
                        "cmp_index": -1
                    }
                ]
            }
        ]
    },
    {
        error_id: 'T-FLW-02',
        data: [
            {
                "profile_name": "100yr (1%)",
                "base": {
                    "up_type": "0",
                    "up_value": null,
                    "up_text": null,
                    "dn_type": "1",
                    "dn_value": "568.48",
                    "dn_text": "Known WS"
                },
                "cmp": {
                    "up_type": "3",
                    "up_value": "0.008",
                    "up_text": "Normal Depth S",
                    "dn_type": "3",
                    "dn_value": "0.006",
                    "dn_text": "Normal Depth S"
                }
            },
            {
                "profile_name": "FW",
                "base": {
                    "up_type": "0",
                    "up_value": null,
                    "up_text": null,
                    "dn_type": "1",
                    "dn_value": "569.33",
                    "dn_text": "Known WS"
                },
                "cmp": {
                    "up_type": "3",
                    "up_value": "0.008",
                    "up_text": "Normal Depth S",
                    "dn_type": "3",
                    "dn_value": "0.006",
                    "dn_text": "Normal Depth S"
                }
            }
        ]
    },
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'FLW-03',
        data: [
            {
                "profile_name": "4420"
            }
        ]
    },
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'FLW-04',
        data: [
            {profile_name: '5505'},
            {profile_name: '7650'},
        ]
    },
    {
        comment: '',
        error_id: 'FLW-05',
        data: [
            {profile_name: 'Fut100'},
            {profile_name: '500yr (0.2%)'},
        ]
    },
    {
        comment: '',
        error_id: 'FLW-06',
        data: [
            {
                "profile_name": "10yr (10%)"
            }
        ]
    },
    {
        comment: '',
        error_id: 'FLW-00',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
]